import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4bc361f8&scoped=true&"
import script from "./main.js?vue&type=script&lang=js&"
export * from "./main.js?vue&type=script&lang=js&"
import style0 from "./main.scss?vue&type=style&index=0&id=4bc361f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc361f8",
  null
  
)

export default component.exports